import toastr from 'toastr'

const computed = {
  channelApiStatistics () {
    return _.cloneDeep(this.$store.state.reports.channelApiStatistics)
  },
  formattedRawData () {
    if (this.rawData === null || this.rawData === undefined) {
      return 'No data'
    }
    if (_.isString(this.rawData)) {
      return this.rawData
    }
    return JSON.stringify(this.rawData, null, 2)
  }
}

const methods = {
  displayErrors (errors) {
    this.$emit('channelApiStatisticsErrors', errors)
  },

  formatValue (value) {
    if (value === null || value === undefined) {
      return ''
    }
    if (_.isObject(value)) {
      return JSON.stringify(value)
    }
    return value
  }
}

export default {
  name: 'reports-channel_api_statistics',
  props: ['url'],
  computed,
  methods,
  data () {
    return {
      processing: false,
      columns: [],
      rows: [],
      rawData: null,
      isTable: false
    }
  },
  created () {
    this.processing = true
    this.$store.dispatch('reports.getChannelApiStatistics', this.url).then(() => {
      this.processing = false
      if (this.$store.state.reports.errors) {
        toastr.error(this.$store.state.reports.errors.message)
        return
      }

      let data = this.channelApiStatistics

      if (_.isArray(data) && data.length) {
        if (_.isPlainObject(data[0])) {
          this.columns = Object.keys(data[0])
          this.rows = data
          this.isTable = true
        } else if (_.isArray(data[0])) {
          this.columns = data[0]
          this.rows = data.slice(1)
          this.isTable = true
        } else {
          this.rawData = data
        }
      } else if (_.isPlainObject(data)) {
        this.columns = Object.keys(data)
        this.rows = [data]
        this.isTable = true
      } else {
        this.rawData = data
      }
    })
  },
  beforeDestroy () {
    this.$store.dispatch('reports.resetReports')
  }
}
